import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5137c92e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5137c92e')) {
      api.createRecord('5137c92e', component.options)
    } else {
      api.reload('5137c92e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5137c92e&", function () {
      api.rerender('5137c92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/messages/index.vue"
export default component.exports